// Converts error arrays to string for simple output
// skipTypes will only work if used with https://github.com/thebigredgeek/apollo-errors
export default function({graphQLErrors, networkError}, skipTypes = []) {
  let skip = false;
  let errorMessage = '';
  if (graphQLErrors) {
    errorMessage = graphQLErrors.reduce((result, {message, name}, i, {length}) => {
      skip = skip || skipTypes.indexOf(name) !== -1;
      result += message;
      if (i < length - 1) result += '\n\n';
      return result;
    }, errorMessage);
  }
  if (skip) return;

  if (networkError) {
    skip = skipTypes.indexOf(networkError.name) !== -1;
    if (errorMessage) {
      errorMessage += '\n\n';
    } else if (skip) {
      return;
    }
    if (!skip) errorMessage += 'Leider ist ein Problem mit der Verbindung aufgetreten.'; // Todo: translate
  }
  return errorMessage;
}
